var map = {
	"./Group.png": 45940,
	"./aboutus-icon1.svg": 23057,
	"./add-circle.png": 16459,
	"./angry.svg": 29950,
	"./anguish.svg": 15314,
	"./atom-bond2.svg": 70276,
	"./ban-img-icon-4.svg": 29049,
	"./ban-img-icon5.svg": 17183,
	"./ban-img-icon6.svg": 38156,
	"./ban-six-icon1.svg": 33998,
	"./ban-six-icon2.svg": 28365,
	"./ban-six-icon3.svg": 92908,
	"./bath-tub.svg": 18650,
	"./bottel.svg": 95737,
	"./browse-01.jpg": 21863,
	"./browse-02.jpg": 5368,
	"./browse-03.jpg": 50197,
	"./browse-04.jpg": 13134,
	"./browse-05.jpg": 8971,
	"./camera.svg": 80662,
	"./cardiology.png": 92356,
	"./ch.svg": 62870,
	"./check.svg": 87121,
	"./choose-01.svg": 99056,
	"./choose-02.svg": 39747,
	"./choose-03.svg": 25106,
	"./choose-04.svg": 59037,
	"./choose-icon1.svg": 31659,
	"./choose-icon2.svg": 92824,
	"./choose-icon3.svg": 27689,
	"./choose-icon4.svg": 25094,
	"./clinic-01.png": 41493,
	"./clinic-02.png": 55742,
	"./clinic-03.png": 27079,
	"./clinic-04.png": 51912,
	"./clinic-05.png": 91857,
	"./clinic-06.png": 67194,
	"./clinic-07.png": 88771,
	"./clinic-08.png": 44900,
	"./clinic-09.png": 71053,
	"./clinic-10.png": 28119,
	"./clinic-11.png": 85102,
	"./clinic-12.png": 56901,
	"./clinic-13.png": 27484,
	"./clinic-hover-01.png": 97898,
	"./clinic-hover-02.png": 46881,
	"./clinic-hover-03.png": 78616,
	"./clinic-hover-04.png": 53783,
	"./clinic-hover-05.png": 10766,
	"./clinic-hover-06.png": 82565,
	"./clinic-hover-07.png": 53148,
	"./clinic-hover-08.png": 56747,
	"./clinic-hover-09.png": 35618,
	"./clinic-hover-10.png": 77576,
	"./contact-icon1.svg": 79114,
	"./count-01.svg": 56292,
	"./count-02.svg": 27095,
	"./count-03.svg": 21766,
	"./count-04.svg": 91177,
	"./customer-service-1.svg": 23707,
	"./customer-service-2.svg": 42344,
	"./device-message.svg": 37807,
	"./discover-1.svg": 3820,
	"./discover-2.svg": 82847,
	"./discover-3.svg": 68206,
	"./discover-4.svg": 79761,
	"./discover-5.svg": 65376,
	"./doc-01.svg": 15581,
	"./doc-02.svg": 77758,
	"./doc-03.svg": 40335,
	"./doct-01.png": 49919,
	"./doct-02.png": 64644,
	"./doctor-icon.svg": 54708,
	"./down-arrow-gray-dark.svg": 91006,
	"./down-arrow-gray.svg": 49397,
	"./drugs-svg.svg": 76857,
	"./edit.svg": 96415,
	"./email-icon.svg": 82165,
	"./email.svg": 52641,
	"./experience-1.svg": 77889,
	"./experience-2.svg": 84754,
	"./experience-3.svg": 99395,
	"./experience-4.svg": 29212,
	"./experience-5.svg": 18685,
	"./experience-6.svg": 64510,
	"./eye-bg.png": 40204,
	"./eye-icon-01.svg": 78208,
	"./eye-icon.svg": 96468,
	"./eye-white-icon.svg": 24208,
	"./facts-1.svg": 5526,
	"./facts-2.svg": 46773,
	"./facts-3.svg": 4788,
	"./facts-4.svg": 54203,
	"./facts-5.svg": 20010,
	"./female.png": 20305,
	"./fifteen-play.svg": 14301,
	"./file.png": 12687,
	"./fluent-password.svg": 65217,
	"./globe.svg": 37410,
	"./google-icon.svg": 68648,
	"./header-icon.svg": 31430,
	"./health-care-1.svg": 25227,
	"./health-care-love.svg": 36446,
	"./healthcare.svg": 20510,
	"./heart-2.svg": 88932,
	"./heart-pulse-fill.svg": 2585,
	"./hex-shape.png": 52006,
	"./hreat-pulse.svg": 88325,
	"./injection.svg": 45306,
	"./lock.svg": 11674,
	"./male.png": 6582,
	"./mic-black.svg": 6102,
	"./mobile-icon.svg": 58709,
	"./mobile.svg": 1857,
	"./password-duotone.svg": 1075,
	"./patient-icon.svg": 75272,
	"./payment-card.png": 82248,
	"./pet-doctor.svg": 5190,
	"./phone-icon.svg": 93261,
	"./phone.png": 79085,
	"./price-icon1.svg": 4181,
	"./price-icon2.svg": 32310,
	"./price-icon3.svg": 96135,
	"./rainbow-1.png": 37713,
	"./rainbow-3.svg": 46571,
	"./rainbow-4.svg": 78980,
	"./search-icon.svg": 4923,
	"./serv-img-icon-1.svg": 68019,
	"./serv-img-icon-2.svg": 97120,
	"./serv-img-icon-3.svg": 59921,
	"./set-cat-01.png": 11888,
	"./set-cat-02.png": 77291,
	"./set-cat-03.png": 13634,
	"./signup-unlock.svg": 92988,
	"./signup-users.svg": 7952,
	"./smart-phone.svg": 5657,
	"./smile.svg": 16521,
	"./smiling-icon.svg": 88174,
	"./star.svg": 44543,
	"./success-tick.svg": 47246,
	"./syringe-svg.svg": 73251,
	"./test-line.svg": 86570,
	"./tick-icon.svg": 1418,
	"./today-icon.svg": 34944,
	"./up-cam.png": 35628,
	"./up-img-1.svg": 96596,
	"./user-doctor.svg": 7842,
	"./video-icon.svg": 23810,
	"./visit-01.png": 69694,
	"./visit-02.png": 71797,
	"./visit-03.png": 19532,
	"./we-are-icon1.svg": 99041,
	"./we-are-icon2.svg": 5906,
	"./we-are-icon3.svg": 20547,
	"./work-01.svg": 75736,
	"./work-02.svg": 33803,
	"./work-03.svg": 56282,
	"./work-04.svg": 63461,
	"./x-icon-01.png": 7771,
	"./x-icon.svg": 65517
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59945;